var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.classes,
      attrs: { type: "button", title: "Add to cart" },
      on: { click: _vm.onClick },
    },
    [
      _vm.showCheck
        ? _c("add-to-cart-check")
        : _vm.showSpinner
        ? _c("add-to-cart-spinner")
        : _c("add-to-cart-icon"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }